import { DITypes } from "@/core/@types/types";
import { ILogoutGateway } from "@/core/services/user/logout/LogoutGateway";
import LogoutHttpGateway from "@/core/services/user/logout/LogoutHttpGateway";
import { IWhatsAppGateway } from "@/core/services/user/whatsapp/WhatsAppGateway";
import WhatsAppHttpGateway from "@/core/services/user/whatsapp/WhatsAppHttpGateway";
import { ContainerModule } from "inversify";

const userContainer = new ContainerModule((bind) => {
  bind<ILogoutGateway>(DITypes.USER_LOGOUT).to(LogoutHttpGateway);
  bind<IWhatsAppGateway>(DITypes.USER_WHATSAPP).to(WhatsAppHttpGateway);
});

export { userContainer };
